import * as React from "react";
import { PolymorphicPlayerCard } from "../../../../../services/bedrock";
import { Dropdown } from "semantic-ui-react";
import { useFormContext, useWatch } from "react-hook-form";
import { useContext } from "react";
import PlayerCardField from "./Fields/PlayerCardField";
import { PlayerCardSettingsContext } from "../../../Contexts";
import RecordSelector from "../../../RecordSelector";
import CustomTitleField from "./Fields/CustomTitleField";

interface BlogWidgetSettingsProps {
  index: number;
}

const BlogWidgetSettings: React.FC<BlogWidgetSettingsProps> = ({ index }) => {
  const { control } = useFormContext<PolymorphicPlayerCard>();
  const { Blogs } = useContext(PlayerCardSettingsContext);
  const selectionType = useWatch({ control, name: `widgets.${index}.owner.selectionType` });

  return (
    <div className="playerCardWidgetOwner playerCardBlog">
      <PlayerCardField
        index={index}
        fieldName="selectionType"
        fieldLabel="Selection Type"
        rules={{ required: "This is required." }}
        component={Dropdown}
        placeholder="Selection Type"
        selection
        options={[
          { text: "Specific", value: "SPECIFIC" },
          { text: "Random", value: "RANDOM" },
          { text: "Most Recent", value: "MOST_RECENT" },
        ]}
      />
      {selectionType === "SPECIFIC" && (
        <PlayerCardField
          index={index}
          fieldName="blogId"
          fieldLabel="Blog"
          rules={{ required: "This is required." }}
          component={RecordSelector}
          context={Blogs}
        />
      )}
      <CustomTitleField index={index} />
    </div>
  );
};
export default BlogWidgetSettings;
